import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

function load(componentName) {
  return () => import(/* webpackChunkName: "[request]" */ `@/components/${componentName}`);
}

const router = new VueRouter({
  base: '/',
  routes: [
    { 
      path: '/', 
      name: 'Home',
      component: load('Home'),
      meta: { keepAlive: true }
    },
    { 
      path: '/reel',
      name: 'Reel',
      component: load('Reel'),
      meta: { keepAlive: true }
    },
    { 
      path: '/project/:url', 
      name: 'Project',
      component: load('Project'),
      meta: { keepAlive: false }
    },
    { 
      path: '/thanks', 
      name: 'success',
      component: load('Thanks'),
      meta: { keepAlive: false }
    },
    {
      path: '/uh-oh',
      name: 'fail',
      component: load('EpicFail'),
      meta: { keepAlive: false }
    },
    { 
      path: '*', 
      name: 'NotFound',
      component: load('NotFound'),
      meta: { keepAlive: false }
    },
  ],
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    // Don't scroll immediately when going to project pages - let transition handle it
    if (to.name === 'Project') {
      return false;
    }
    // Don't scroll immediately when returning from project to home - let transition handle it
    if (from.name === 'Project' && to.name === 'Home') {
      return false;
    }
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;